import Vue from 'vue';
import App from './snowLeopard.vue';
import EchojoyMessage from '@/components/message/message';
import Carousel3d from 'vue-carousel-3d';
// import('./assets/scss/common.scss')
let typePage = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) ? 'm' : 'images';
if(typePage === 'm'){
  import('@/assets/scss/m-css.scss')
} else {
  import('@/assets/scss/pc-css.scss')
}

Vue.use(Carousel3d);
Vue.config.productionTip = false;
Vue.prototype.$message = EchojoyMessage;
Vue.prototype.$typePage = typePage;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
